module.exports = __webpack_public_path__ + "img/I-09187_00-e.13c39c00.jpg";